import { render, staticRenderFns } from "./adminMsgForm.vue?vue&type=template&id=c52d9610&scoped=true"
import script from "./adminMsgForm.vue?vue&type=script&lang=js"
export * from "./adminMsgForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52d9610",
  null
  
)

export default component.exports